import React from "react";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";

const FormFieldLabel = ({
  children,
  required = false,
  className = "label-input",
  ...rest
}) => {
  return (
    <Form.Label
      className={`${className}${required ? " label-input--required" : ""}`}
      {...rest}
    >
      {children}
    </Form.Label>
  );
};

FormFieldLabel.propTypes = {
  children: PropTypes.node.isRequired,
  required: PropTypes.bool,
  className: PropTypes.string,
};

export default FormFieldLabel;
